import React from 'react';
import createStore from './store/ContentWrapperStore';
import { RootProvider } from '@everfi/reactifi/src/react-on-rails/RootProvider';
import ContentWrapper from './containers/ContentWrapper';

export default (props, _railsContext) => {
  const store = createStore(props || {});

  return (
    <RootProvider store={store}>
      <ContentWrapper {...props} contentServiceUrl={_railsContext.content_service_url} jwt={_railsContext.jwt} />
    </RootProvider>
  );
};
